export const ENTITY_PROFILE_HEADER_EDITABLE_AVATAR_MENU_ACTION = {
  DELETE: 'delete',
  EDIT: 'edit',
}

export const QA_NAME_ENTITY_PROFILE_HEADER_EDITABLE_AVATAR =
  'entityProfileHeaderEditableAvatar'

export const QA_NAME_ENTITY_PROFILE_HEADER_EDITABLE_AVATAR_DELETE =
  'entityProfileHeaderEditableAvatarDelete'

export const ENTITY_PROFILE_HEADER_EDITABLE_AVATAR_DROPDOWN_CONFIG = {
  dropdownStyles: {
    maxWidth: 288, // px
  },
  maxWidthByRef: false,
}
